// BUG-241 — 브라우저가 사이트 데이터를 차단하면 localStorage 접근이 SecurityError 를 던져
// main chunk 모듈 평가 시점에 부팅이 중단되고 흰 화면이 된다. 이 모듈은 모든 localStorage
// 접근을 try/catch 로 감싸 실패를 null/false 로 흡수하고 console.warn 으로 노출한다
// (무음 차단 금지 — 저장소 CLAUDE.md silent-drop 규칙).
//
// 부팅 최상단에서 평가되므로 다른 어떤 모듈도 import 하지 않는다(순환 import 방지).

const warn = (op, key, e) => {
    console.warn('[safeStorage] localStorage access failed', {
        op,
        key,
        reason: e?.name || e?.message || String(e),
    });
};

export const safeGetItem = (key) => {
    try {
        if (typeof localStorage === 'undefined') {
            warn('getItem', key, { name: 'Unavailable', message: 'localStorage is undefined' });
            return null;
        }
        return localStorage.getItem(key);
    } catch (e) {
        warn('getItem', key, e);
        return null;
    }
};

export const safeSetItem = (key, value) => {
    try {
        if (typeof localStorage === 'undefined') {
            warn('setItem', key, { name: 'Unavailable', message: 'localStorage is undefined' });
            return false;
        }
        localStorage.setItem(key, value);
        return true;
    } catch (e) {
        warn('setItem', key, e);
        return false;
    }
};

export const safeRemoveItem = (key) => {
    try {
        if (typeof localStorage === 'undefined') {
            warn('removeItem', key, { name: 'Unavailable', message: 'localStorage is undefined' });
            return false;
        }
        localStorage.removeItem(key);
        return true;
    } catch (e) {
        warn('removeItem', key, e);
        return false;
    }
};

// getItem + JSON.parse 를 합성. 빈 문자열/'undefined' 문자열/잘못된 JSON/비객체 결과는
// 모두 null 로 흡수한다. getItem 실패는 safeGetItem 이 이미 warn 하므로 여기서는
// parse 실패에 한해서만 별도 warn 한다.
export const safeGetJSON = (key) => {
    const raw = safeGetItem(key);
    if (!raw || raw === 'undefined') return null;
    try {
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') return null;
        return parsed;
    } catch (e) {
        warn('parseJSON', key, e);
        return null;
    }
};
